import { formatDate } from "@cp/toolkit";
import type { InboxFullMessageFragment } from "@qw/graphql";
import type { FC } from "react";

import { DraftEditorReferenceMessageContent } from "./draft-editor-reference-message-content";
import { DraftMessageEmailLink } from "./draft-message-email-link";

interface DraftEditorReferenceMessageForwardProps {
  message: InboxFullMessageFragment;
}

export const DraftEditorReferenceMessageForward: FC<DraftEditorReferenceMessageForwardProps> = ({ message }) => (
  <>
    <p>
      ---------- Forwarded message ---------
      <br />
      From: <DraftMessageEmailLink email={message.from} />
      <br />
      Date: {formatDate(new Date(message.date), "E, LLL d, yyyy 'at' h:mm a")}
      <br />
      Subject: {message.subject}
      <br />
      To:{" "}
      {message.to.map((email, index) => (
        <DraftMessageEmailLink key={index} email={email} />
      ))}
      {message.cc.length > 0 ? (
        <>
          <br />
          Cc:{" "}
          {message.cc.map((email, index) => (
            <DraftMessageEmailLink key={index} email={email} />
          ))}
        </>
      ) : (
        ""
      )}
    </p>

    <DraftEditorReferenceMessageContent message={message} />
  </>
);
